'use strict';
import tagsManageTemplate from './controllers/tags-manage.html';
import tagsManageTaggablesTemplate from './controllers/tags-manage-taggables.html';


/**
 * @param config
 * @param config.viewName
 * @param config.createName
 * @param config.manageTaggablesName
 */
export function createManageTagState(config) {
  const state = {
    url: '/data-tags/manage/:collection/:id',
    views: {},
    resolve: {
      manageTaggablesName: () => config.manageTaggablesName,
    },
  };

  state.views[config.viewName] = {
    template: tagsManageTemplate,
    controller: 'DataTagsManageController',
  };

  return state;
}

/**
 * @param config
 * @param config.viewName
 * @param config.manageName
 * @param config.sourceName The state name associated with the tags to manage
 */
export function createManageTaggablesState(config) {
  const state = {
    url: '/data-tags/manage-tags/:collection/:id',
    views: {},
    resolve: {
      taggable: ['$stateParams', '$domain', 'AppBootstrapper', resolveTaggable],
      manageName: () => config.manageName,
      sourceName: () => config.sourceName,
    },
  };

  state.views[config.viewName] = {
    template: tagsManageTaggablesTemplate,
    controller: 'DataTagsManageTaggedController',
  };

  return state;
}

function resolveTaggable($stateParams, $domain, AppBootstrapper) {
  if ($stateParams.collection && $stateParams.id) {
    return AppBootstrapper.loaded()
      .then(() =>
        $domain.getDomain($stateParams.collection)
          .$get($stateParams.id)
          .catch(e => null)
      );
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/js/data-tags/DATA_TAG_STATES.js